// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-form-header {
  background: #fff;
  padding: 25px 20px 15px;
  display: flex;
  -webkit-display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.page-heading {
  font-size: 18px;
  color: #222222;
  font-weight: 700;
}
.page-navigation-buttons {
  display: flex;
}
.page-navigation-buttons .back-navigation,
.page-navigation-buttons .forward-navigation {
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  position: relative;
}
.forward-navigation:before,
.back-navigation:before {
  height: 12px;
  width: 12px;
  border-bottom: 2px solid #222;
  content: "";
  position: absolute;
  top: 10px;
}
.forward-navigation:before {
  border-right: 2px solid #222;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
}
.back-navigation:before {
  border-left: 2px solid #222;
  transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
}

.username-caseid-wrapper {
  padding: 8px 20px;
  background: #f4f7fa;
  display: flex;
  justify-content: space-between;
}
.username-caseid-wrapper .username,
.username-caseid-wrapper .caseid-label {
  font-size: 14px;
  color: #000000;
  line-height: 1.4;
}
.username-caseid-wrapper .caseid-value {
  color: #e0a633;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 700;
}
.common-form-header .button {
  margin-right: 10px;
}
.hideBtn {
  display: none;
}
.markSectionDone {
  padding-top: 4px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cancel-btn {
  margin-right: 10px;
}
.mark-done-field-label {
  margin-right: 5px;
  font-size: 16px;
  color: #1984bc;
  font-weight: 600;
  display: inline-block;
  width: 205px;
}
.modal-contents {
  line-height: 20px;
}
.otherCaseData--selectbox {
  padding: 0 20px 10px;
  background: #fff;
}
.otherCaseData--selectbox .label-value-wrapper {
  margin-bottom: 0;
}
.otherCaseData--selectbox option {
  margin-bottom: 5px;
}
.otherCaseData--selectbox option span {
  margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/commonFormHeader/CommonFormHeader.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;;EAEf,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B;EAC7B,iCAAiC;EACjC,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;AACA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".common-form-header {\n  background: #fff;\n  padding: 25px 20px 15px;\n  display: flex;\n  -webkit-display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.page-heading {\n  font-size: 18px;\n  color: #222222;\n  font-weight: 700;\n}\n.page-navigation-buttons {\n  display: flex;\n}\n.page-navigation-buttons .back-navigation,\n.page-navigation-buttons .forward-navigation {\n  display: flex;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  position: relative;\n}\n.forward-navigation:before,\n.back-navigation:before {\n  height: 12px;\n  width: 12px;\n  border-bottom: 2px solid #222;\n  content: \"\";\n  position: absolute;\n  top: 10px;\n}\n.forward-navigation:before {\n  border-right: 2px solid #222;\n  transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n}\n.back-navigation:before {\n  border-left: 2px solid #222;\n  transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n}\n\n.username-caseid-wrapper {\n  padding: 8px 20px;\n  background: #f4f7fa;\n  display: flex;\n  justify-content: space-between;\n}\n.username-caseid-wrapper .username,\n.username-caseid-wrapper .caseid-label {\n  font-size: 14px;\n  color: #000000;\n  line-height: 1.4;\n}\n.username-caseid-wrapper .caseid-value {\n  color: #e0a633;\n  font-size: 14px;\n  line-height: 1.4;\n  font-weight: 700;\n}\n.common-form-header .button {\n  margin-right: 10px;\n}\n.hideBtn {\n  display: none;\n}\n.markSectionDone {\n  padding-top: 4px;\n  margin-right: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.cancel-btn {\n  margin-right: 10px;\n}\n.mark-done-field-label {\n  margin-right: 5px;\n  font-size: 16px;\n  color: #1984bc;\n  font-weight: 600;\n  display: inline-block;\n  width: 205px;\n}\n.modal-contents {\n  line-height: 20px;\n}\n.otherCaseData--selectbox {\n  padding: 0 20px 10px;\n  background: #fff;\n}\n.otherCaseData--selectbox .label-value-wrapper {\n  margin-bottom: 0;\n}\n.otherCaseData--selectbox option {\n  margin-bottom: 5px;\n}\n.otherCaseData--selectbox option span {\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
